import { gql } from '@apollo/client';

export const fetchCampaignsAssociatedWithListQuery = gql`
  query getCampaignsAssociatedWithList(
    $filter: CampaignFilterInfoInput
    $pagination: Pagination
    $sort: Sort
  ) {
    campaigns(campaignFilterInfo: $filter, pagination: $pagination, sort: $sort) {
      results {
        id
        name
        campaignState
        messageMedium
        updatedAt
      }
    }
  }
`;
